import { cn } from '@/ui/cn';

/** The platform's name, wherever it is spelled out. */
export const PLATFORM_NAME = 'Saarthi E-Commerce';

/**
 * The platform's logo: on the admin console, the sign-in screens and the
 * "Powered by" line under every shop.
 *
 * Not a shop's logo - each shop's own header shows theirs. The artwork has a
 * white ground, so on a dark surface it sits on a white tile rather than as a
 * white square with no edge.
 */
export function PlatformLogo({ size = 40, withName = false, className, nameClassName }) {
  return (
    <span className={cn('inline-flex items-center gap-2.5', className)}>
      <span
        className="inline-flex shrink-0 items-center justify-center overflow-hidden rounded-lg bg-white"
        style={{ width: size, height: size }}
      >
        <img
          src={size > 96 ? '/icons/logo_384x384.png' : '/icons/logo_192x192.png'}
          alt={withName ? '' : PLATFORM_NAME}
          width={size}
          height={size}
          className="h-full w-full object-contain"
        />
      </span>
      {withName && <span className={cn('font-semibold', nameClassName)}>{PLATFORM_NAME}</span>}
    </span>
  );
}
